import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cardapio-minishop-footer',
  templateUrl: './cardapio-minishop-footer.component.html',
  styleUrls: ['./cardapio-minishop-footer.component.scss'],
})
export class CardapioMinishopFooterComponent implements OnInit, OnDestroy {
  @Output() verMenu = new EventEmitter<void>();
  @Output() qrLinks = new EventEmitter<void>();

  texts = {
    ver_menu: '',
    qr_links: '',
  };

  private langChangeSub!: Subscription;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.loadTranslations();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.loadTranslations();
    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSub) this.langChangeSub.unsubscribe();
  }

  private loadTranslations(): void {
    this.texts = {
      ver_menu: this.translate.instant('cardapio_minishop.footer.ver_menu'),
      qr_links: this.translate.instant('cardapio_minishop.footer.qr_links'),
    };
  }
}
